export default __webpack_public_path__ + "static/media/article05.7fbb43e9.md";